import {Component, Inject, OnInit} from '@angular/core';
import {ConfirmModalOptions, ModalOutputInterface} from "@models";
import { NgClass } from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    imports: [
    NgClass,
    MatButtonModule
]
})
export class ConfirmModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModalOptions,
    public dialogRef: MatDialogRef<ConfirmModalComponent,ModalOutputInterface>
  ) {
  }

  ngOnInit(): void {
  }

  public onClose(isConfirm: boolean = false): void {
    this.dialogRef.close({continue:isConfirm})
  }
}
